import { PaymentService, InvoiceService } from '@services';
import { apiErrorHandler, updateProgressButton } from '@redux-core/helpers';
import { replace } from 'react-router-redux';
import utils, { constants } from '@utils';
import Actions from '.';

const { BULK_PAYMENT_STATUSES } = constants;
export const BULK_PAYMENT_JOB_TIMER = 10000;

/* ------------- Thunks actions ------------- */
export const getInvoice = (hash, bulk = false) => ((dispatch) => {
	dispatch(Actions.setLoading('invoice', true));

	InvoiceService[bulk ? 'getBulkQuickPayInvoice' : 'getQuickPayInvoice'](hash)
		.then(({ data }) => {
			dispatch(Actions.receiveInvoice(data, hash));
			dispatch(Actions.setLoading('invoice', false));
		})
		.catch((error) => {
			dispatch(Actions.setLoading('invoice', false));

			// if the error has statusCode 404 there is no invoice and we do not show the quickpay page
			if (error.response && error.response.status === 404) {
				dispatch(replace({ pathname : '/404' }));
				return;
			}

			// if the error has statusCode 400 the invoice is already paid and we show a success message
			if (error.response && error.response.status === 400) {
				dispatch(Actions.receiveInvoice({}, hash));
				dispatch(replace({ pathname : `/quickpay/paid/${hash}` }));
				return;
			}

			apiErrorHandler({
				dispatch,
				module         : 'quickpay',
				property       : 'loaders.invoice',
				defaultMessage : 'Error loading invoice',
			})(error);
		});
});

const checkPaymentStatus = (JobId) => ((dispatch) => {
	let intervalRef = null;

	dispatch(Actions.setLoading('invoice', true));

	const checkPaymentRequest = () => {
		PaymentService.verifyBulkPaymentStatus(JobId)
			.then(({ data }) => {
				const { StatusId } = data;

				if (StatusId === BULK_PAYMENT_STATUSES.SUCCEEDED) {
					utils.notify({
						type    : 'success',
						title   : 'Payment Completed',
						message : 'The invoice has been paid',
					});

					dispatch(Actions.receiveReceipt(data));
					dispatch(Actions.updateStep(3));
				} else if (StatusId === BULK_PAYMENT_STATUSES.FAILED || StatusId === BULK_PAYMENT_STATUSES.CHARGE_FAILED) {
					utils.notify({
						type    : 'error',
						title   : 'Payment Failed',
						message : 'The invoice payment has failed',
					});
				}

				if (StatusId === BULK_PAYMENT_STATUSES.SUCCEEDED
					|| StatusId === BULK_PAYMENT_STATUSES.FAILED
					|| StatusId === BULK_PAYMENT_STATUSES.CHARGE_FAILED) {
					dispatch(Actions.setLoading('invoice', false));
					clearInterval(intervalRef);
				}
			})
			.catch(apiErrorHandler({
				dispatch,
				module   : 'quickpay',
				property : 'loading.invoice',
			}));
	};

	intervalRef = setInterval(checkPaymentRequest, BULK_PAYMENT_JOB_TIMER);
});

export const makeQuickPayPayment = (token, type) => ((dispatch, getState) => {
	const {
		quickpay : {
			invoice,
			inputData : { sendEmailReceipt },
			hash,
		},
	} = getState();

	let TotalInvoice = 0;
	if (type === '1') TotalInvoice = invoice.TotalInvoice;
	else if (type === 'bulk') TotalInvoice = invoice.Total;

	const paymentData = { hash, TotalInvoice, sendEmailReceipt };

	let endpoint = '';
	if (type === '1') endpoint = 'makeQuickPayPayment';
	else if (type === 'bulk') endpoint = 'makeBulkQuickPayPayment';

	const data = {
		StripeCreditToken : token.id,
		Amount            : paymentData.TotalInvoice,
		InvoiceToken      : paymentData.hash,
		SendEmailReceipt  : paymentData.sendEmailReceipt,
	};

	PaymentService[endpoint](data)
		.then(({ data : { JobId } }) => {
			dispatch(updateProgressButton({
				module   : 'quickpay',
				property : 'loaders.paymentInfoButton',
				value    : '',
			}));

			utils.notify({
				type    : 'info',
				title   : '',
				message : 'Payment processing...',
			});

			dispatch(checkPaymentStatus(JobId));
		})
		.catch((err) => apiErrorHandler({
			dispatch,
			usingProgressButton : true,
			module              : 'quickpay',
			property            : 'loaders.paymentInfoButton',
			value               : 'error',
			defaultMessage      : 'Error making payment',

		})(err));
});

export default {
	getInvoice,
	makeQuickPayPayment,
	checkPaymentStatus,
};
